import TestsOM = require("TestManagement/Scripts/TFS.TestManagement");

export class CSVRowViewModel {

    constructor(testCaseTitle?: string, actionId?: number, action?: string, expectedResult?: string, testCase?: TestsOM.TestCase, isTestCase?: boolean, isSharedStep?: boolean, refId?: number, additionalFields?: any, revision?: number) {
        this.testCaseTitle = testCaseTitle || "";
        this.action = action || "";
        this.expectedResult = expectedResult || "";
        this.additionalFields = additionalFields || {};
        this.actionId = actionId;
        this.isTestCase = isTestCase;
        this.testCase = testCase || null;
        this.isSharedStep = isSharedStep;
        this.refId = refId;
    }

    public getValue(property: string) {
        if (property === "id") {
            if (this.testCase && this.isTestCase && this.testCase.getId() > 0) {
                return this.testCase.getId();
            }
            else {
                return "";
            }
        }
        else if (this.additionalFields.hasOwnProperty(property)) {
            return this.additionalFields[property];
        }
        else {
            return this[property];
        }
    }

    public testCaseTitle: string;
    public action: string;
    public expectedResult: string;
    public additionalFields: any;
    public testCase: TestsOM.TestCase;
    public actionId: number;
    public isTestCase: boolean;
    public isSharedStep: boolean;
    public refId: number;
}